module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home"
  }, [_vm._m(0), _vm._v(" "), _c('header', [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "intro-text"
  }, [_c('div', {
    staticClass: "intro-lead-in"
  }, [_vm._v(_vm._s(_vm.appName))]), _vm._v(" "), _c('div', {
    staticClass: "intro-heading"
  }, [_vm._v("A new way to share your videos")]), _vm._v(" "), _c('a', {
    staticClass: "page-scroll btn btn-xl m-2",
    attrs: {
      "href": "#services"
    }
  }, [_vm._v("Tell Me More")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-xl m-2",
    attrs: {
      "href": _vm.downloadLink,
      "target": "_blank"
    },
    on: {
      "click": function($event) {
        _vm.trackClick(_vm.downloadLink)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-download fa-fw",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Download")])])])]), _vm._v(" "), _c('services'), _vm._v(" "), _c('portfolio-grid'), _vm._v(" "), _c('about'), _vm._v(" "), _c('team'), _vm._v(" "), _c('contact'), _vm._v(" "), _c('footer', [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('span', {
    staticClass: "copyright"
  }, [_vm._v("Copyright © " + _vm._s(_vm.appName) + " 2017")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('ul', {
    staticClass: "list-inline social-buttons"
  }, [_c('li', {
    staticClass: "list-inline-item"
  }, [_c('a', {
    attrs: {
      "href": _vm.paypalLink,
      "target": "_blank",
      "title": "Donate"
    },
    on: {
      "click": function($event) {
        _vm.trackClick(_vm.paypalLink)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-paypal"
  })])])])]), _vm._v(" "), _vm._m(1)])])]), _vm._v(" "), _c('portfolio-modals')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "navbar fixed-top navbar-toggleable-md navbar-inverse",
    attrs: {
      "id": "mainNav"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('button', {
    staticClass: "navbar-toggler navbar-toggler-right",
    attrs: {
      "type": "button",
      "data-toggle": "collapse",
      "data-target": "#navbarResponsive",
      "aria-controls": "navbarResponsive",
      "aria-expanded": "false",
      "aria-label": "Toggle navigation"
    }
  }, [_vm._v("\n        Menu "), _c('i', {
    staticClass: "fa fa-bars"
  })]), _vm._v(" "), _c('a', {
    staticClass: "navbar-brand page-scroll",
    attrs: {
      "href": "#app"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/logo.svg")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "collapse navbar-collapse",
    attrs: {
      "id": "navbarResponsive"
    }
  }, [_c('ul', {
    staticClass: "navbar-nav ml-auto"
  }, [_c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link page-scroll",
    attrs: {
      "href": "#services"
    }
  }, [_vm._v("Features")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link page-scroll",
    attrs: {
      "href": "#portfolio"
    }
  }, [_vm._v("Screenshots")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link page-scroll",
    attrs: {
      "href": "#about"
    }
  }, [_vm._v("Getting started")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link page-scroll",
    attrs: {
      "href": "#team"
    }
  }, [_vm._v("Team")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link page-scroll",
    attrs: {
      "href": "#contact"
    }
  }, [_vm._v("Contact")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "https://github.com/mmorainville/netsix",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-github fa-fw",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" GitHub")])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-4"
  }, [_c('span', {
    staticClass: "copyright"
  }, [_vm._v("We will not be responsible for any devious usage of the app.")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3f976f00"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home.vue
// module id = 113
// module chunks = 1